import {
	useMutation,
	useQueryClient,
	type UseMutationOptions,
} from '@tanstack/react-query';
import {splitEventHandler} from '@netx/core-next/utils/fn';
import useDispatcher from '@netx/core-components/hooks/useDispatcher';
import {AssetViewEvent} from '../../actions/constants';
import {
	deleteView,
	type DeleteViewResult,
	type DeleteViewRequestOptions,
	type QueryError,
} from '../deleteView';
import {GetViewObjectsForAssetReactQueryKey} from './getViewObjectsForAsset';

export * from '../deleteView';

export type UseReactQueryDeleteViewOptions = UseMutationOptions<
	DeleteViewResult,
	QueryError,
	DeleteViewRequestOptions,
	DeleteViewResult
>;

export const useReactQueryDeleteView = (
	options: Omit<UseReactQueryDeleteViewOptions, 'mutationFn'> = {},
) => {
	// const queryClient = useQueryClient();

	return useMutation<
		DeleteViewResult,
		QueryError,
		DeleteViewRequestOptions,
		DeleteViewResult
	>({
		mutationFn: deleteView,
		...options,
		onSuccess: splitEventHandler(
			options.onSuccess,
			(data, variables, context) => {
				//
			},
		),
	});
};

export default useReactQueryDeleteView;
